import React, { FC, useEffect, useState } from 'react';
import SurgeScheduleSection from '.';
import { apiService } from 'utils/api';
import SurgeApplyNowSection from '../surge-apply-now';
import { ScheduleSurgePayload, SurgeTabProps } from '../types';

const EditSingleSurgeItem: FC<SurgeTabProps> = ({ confirm, setLoading, onClose, surgeItem }) => {
  const [value, setValue] = useState({} as ScheduleSurgePayload);

  const editScheduledSurge = async () => {
    setLoading(true);
    try {
      const url = 'logistics/super-admin/surge/edit';
      const res = await apiService.post(url, { data: value });
      const data = res?.data?.general_surge_history;
      if (res) onClose();
      return data;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (confirm === 'Edit') {
      editScheduledSurge();
    }
  }, [confirm]);

  return (
    <div>
      <SurgeApplyNowSection
        value={value}
        setValue={(newVal) => setValue({ ...value, ...newVal })}
        hideRemoveSurge
      />
      <SurgeScheduleSection
        value={value}
        setValue={(newVal) => setValue({ ...value, ...newVal })}
        surgeItem={surgeItem}
      />
    </div>
  );
};

export default EditSingleSurgeItem;
